export default __webpack_public_path__ + "assets/1b3a007f512d665b3e0565de9ad6508d.jpg";